import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ZoomIn = function ZoomIn() {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/forbid-elements
    _jsxs("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/_jsx("line", {
        x1: "8",
        x2: "8",
        y2: "16",
        stroke: "#0468FF",
        strokeWidth: "2"
      }), /*#__PURE__*/_jsx("line", {
        x1: "16",
        y1: "8",
        y2: "8",
        stroke: "#0468FF",
        strokeWidth: "2"
      })]
    })
  );
};
ZoomIn.displayName = 'ZoomIn';